import type { ReactElement } from 'react';

import '../../../config/i18n';

import { AdDataProvider } from '@ad-lucy/context/adData';
import { AdStateProvider } from '@ad-lucy/context/adState';
import { CreativesProvider } from '@ad-lucy/context/creativesConfig';
import { PagesProvider } from '@ad-lucy/context/pages';
import { ThemeProvider } from '@ad-lucy/context/ThemeProvider';
import { TrackingProvider } from '@ad-lucy/context/tracking';
import {
  type ContentConfigurationUrls,
  DoohPreloadPause,
  LiveRendering,
  Polyfills,
  Reporter,
  Translations,
} from '@ad-lucy/services';
import { GlobalStyles } from '@ad-lucy/styled';

import type { AdProviderBundleProps } from './types';

export const AdProviderBundle = ({
  children,
  config,
  theme,
  contentUrl,
  globalUrl,
  storesUrl,
}: AdProviderBundleProps & ContentConfigurationUrls): ReactElement => (
  <CreativesProvider config={config}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Polyfills />
      <AdDataProvider contentUrl={contentUrl} globalUrl={globalUrl} storesUrl={storesUrl}>
        <TrackingProvider creativesId={config.id}>
          <Translations />
          <PagesProvider>
            <AdStateProvider>{children}</AdStateProvider>
            <Reporter />
            <LiveRendering />
            <DoohPreloadPause />
          </PagesProvider>
        </TrackingProvider>
      </AdDataProvider>
    </ThemeProvider>
  </CreativesProvider>
);
